import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';
import storage from 'redux-persist/lib/storage';
import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router';

import rootReducer from './rootReducer';

export const sagaMiddleware = createSagaMiddleware();
export const history = createBrowserHistory();
const routerMiddleware = createRouterMiddleware(history);

interface PersistConfig {
  key: string;
  storage: typeof storage;
  whitelist: string[];
}

const persistConfig: PersistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'common']
};

const persistedReducer = persistReducer(persistConfig, rootReducer(history));

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(sagaMiddleware)
      .concat(routerMiddleware)
});

export const persistor = persistStore(store);

export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<ReturnType<typeof rootReducer>>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
